import { new_success} from "../confg";
import {createAction} from "@reduxjs/toolkit";

export const successAction=createAction(new_success);
